import { useState, useEffect } from "react";
import { useAccountPortalState } from "../integration/hooks.js";
import "@crystal/core";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "@crystal/analytics";
import "../config/source-ids.js";
import "../config/presets.js";
import "../ap2/config.js";
import "../ap2/state.js";
import "./config.js";
import "@crystal/config";
import "../state/reducers.js";
import "../state/actions.js";
import { getAccountPortalState } from "../state/utils.js";
function getExternalAuthData() {
  const { eventType, status, error, authContext, pageContext, kmc } = getAccountPortalState() || {};
  const context = authContext;
  const isExtAuthEvent = eventType === "externalAuth";
  const isExtAuthPending = isExtAuthEvent && status === "pending";
  const isExtAuthSuccess = isExtAuthEvent && status === "success";
  const isExtAuthError = isExtAuthEvent && status === "error";
  const isAppRedirectPending = isExtAuthSuccess && !!(authContext == null ? void 0 : authContext.appRedirect);
  return {
    kmc,
    pageContext,
    authContext: context,
    isPending: isExtAuthPending || isAppRedirectPending,
    isSuccess: isExtAuthSuccess && !isAppRedirectPending,
    isCancelled: (context == null ? void 0 : context.isCancelled) || false,
    error: isExtAuthError ? error : void 0
  };
}
function useExternalAuthData() {
  const { eventType, status, authContext } = useAccountPortalState();
  const [externalAuth, setExternalAuth] = useState(getExternalAuthData());
  useEffect(() => {
    if (eventType === "externalAuth") {
      setExternalAuth(getExternalAuthData());
    }
  }, [eventType, status, authContext]);
  return externalAuth;
}
export {
  getExternalAuthData,
  useExternalAuthData
};
//# sourceMappingURL=hooks.js.map
